import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth/auth.service';
import { ConsentService, ConsentSource } from '../services/consent/consent.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router,
                private authService: AuthService,
                private consent: ConsentService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(error => {
            // 403 con code NEED_CONSENT → abrir modal de aceptación, NO cerrar sesión.
            if (error.status === 403 && error?.error?.code === 'NEED_CONSENT') {
                this.consent.requestModal(this.deriveSource(request.url));
                return throwError(error);
            }
            if ((error.status === 401 || error.status === 403) && request.headers.has('Authorization')) {
                this.authService.cerrarSesion();
                this.router.navigate(['/acceder']);
            }
            return throwError(error);
        }));
    }

    /** Heurística: deriva la source del consent a partir del path. */
    private deriveSource(url: string): ConsentSource {
        if (url.includes('/cv/')) return 'cargar_cv';
        if (url.includes('/cv-optimizer')) return 'ia';
        if (url.includes('/postulacion')) return 'postulacion';
        if (url.includes('/gurumatch')) return 'ia';
        return 'perfil';
    }
}
